import React, { useMemo } from 'react';

import { Typography } from '@material-ui/core';
import cx from 'classnames';

import { GlossaryGridHit } from '../GlossaryGridHit';
import { Hit } from '../Hit';
import useStyles from './styles';

type HitsObj = {
  [x: string]: any[];
};

const generateHitsWithLetters = (hits, tenantTitle, classes) => {
  if (hits.length > 0) {
    const res: JSX.Element[] = [];
    const lettersArr: string[] = [];

    hits.forEach((hit) => {
      if (hit?.letter_index && !lettersArr.includes(hit.letter_index)) {
        lettersArr.push(hit.letter_index);
        res.push(
          <li key={hit.letter_index} className={cx(classes.letter, 'hit-letter')}>
            {hit.letter_index}
          </li>,
        );
      }

      res.push(
        <li key={hit.objectID}>
          <Hit hit={hit} tenantTitle={tenantTitle} />
        </li>,
      );
    });

    return res;
  } else {
    return null;
  }
};

const normalizeHits = (hits): HitsObj => {
  const obj = {};

  hits.forEach((hit) => {
    if (hit?.letter_index && hit.letter_index in obj) {
      obj[hit.letter_index].push(hit);
    } else {
      obj[hit.letter_index] = [hit];
    }
  });

  return obj;
};

const GlossaryInfiniteHits = ({ hits, tenantTitle, isGridView = false }) => {
  const classes = useStyles();
  const normalizedHits = useMemo(() => {
    if (isGridView && Array.isArray(hits)) {
      return normalizeHits(hits);
    } else {
      return null;
    }
  }, [hits, isGridView]);

  if (isGridView) {
    return (
      <>
        {normalizedHits &&
          Object.keys(normalizedHits).map((key) => (
            <div key={`index-${key}`} className={classes.letterBlock}>
              <Typography className={classes.letter}>{key}</Typography>
              <div className={classes.hitsBlock}>
                {normalizedHits[key]?.map((hit) => (
                  <GlossaryGridHit
                    key={hit?.id}
                    slug={hit?.slug}
                    title={hit?.title}
                    description={hit?.definition}
                    categories={hit?.categories_array}
                    videoUrl={hit?.video_url}
                  />
                ))}
              </div>
            </div>
          ))}
      </>
    );
  }

  return <>{generateHitsWithLetters(hits, tenantTitle, classes)}</>;
};

export default GlossaryInfiniteHits;
